import { KEY_POSITIONS } from './constants'

type Row = string[]
export type Keyboard = Row[]
export interface KeyPosition { x: number; y: number }
export interface KeyPositions { [key: string]: KeyPosition }

export const getKeyPositionsFromKeyboard = (keyboard: Keyboard): KeyPositions => {
  return keyboard.reduce(
    (keyPositions, row, indexInKeyboard) => {
      const y = indexInKeyboard / (keyboard.length - 1)
      const reducedRow = row.reduce(
        (keyPositionsForRow, key, indexInRow) => {
          const x = indexInRow / (row.length - 1)
          return { ...keyPositionsForRow, [key]: { x, y } }
        },
        {},
      )

      return { ...keyPositions, ...reducedRow }
    },
    {},
  )
}

const drawDot = (p: any, color: 0 | 255, x: number, y: number) => {
  p.push()
  p.strokeWeight(30)
  p.stroke(color)
  p.point(x, y)
  p.pop()
}

export const showKeyIndicator = (p: any): void => {
  const position = KEY_POSITIONS[p.key.toLowerCase()]
  if (position) {
    let { x, y } = position
    drawDot(p, 255, p.width * x, p.height * y)
    setTimeout(() => drawDot(p, 0, p.width * x, p.height * y), 200)
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helpers.ts